import { render, staticRenderFns } from "./AutoInsuranceForm.vue?vue&type=template&id=2b6f5b2e"
import script from "./AutoInsuranceForm.vue?vue&type=script&lang=js"
export * from "./AutoInsuranceForm.vue?vue&type=script&lang=js"
import style0 from "./AutoInsuranceForm.vue?vue&type=style&index=0&id=2b6f5b2e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports